<div class="">
   <div class="flex-container grid m-t-24" [ngClass]="showSidebar ? 'd-none' : ''"  #container><!--p-r-160  -->
    <div *ngFor="
      let entry of dataEntries;
      let indexOfelement=index;
      let isFirst = first;
      let isLast = last;">
        <app-spinner
          class=" internal-unit row-item p-row-item"
          [id]="entry.ID"
          [value]="entry.quantity"
          [title]="entry.name | translate"
          [tooltip]="entry.description | translate"
          [showTooltip]="true"
          [min]="0"
          [max]="5"
          [ngClass]="{
                        'p-t-25': indexOfelement != 0 && indexOfelement != 1,
                        'first': isFirst,
                        'last': isLast,
                        'evidence' : entry.quantity > 0
                      }"
          [lateralPanelId]="'lateral-'+indexOfelement"
          [lateralPanelTitle]="entry.name | translate"
          [showInfoButton]="true"
          [price]="entry.price"
          [showPrice]="true"
          [image]="entry.image"
          (onSpinnerUpd)="onIUSpinnerUpd($event, entry.ID)"
        >
      </app-spinner>
    </div>
  </div>
</div>


<app-lateral-panel div *ngFor="
let entry of dataEntries;
let indexOfelement=index;
"
 id="lateral-{{indexOfelement}}" class="subtitle-info-lateral primary"  [extraClasses]="'grey m-w-768 with-black-band'" [(showSidebar)]="showSidebar">
  <div class="row d-flex justify-content-between align-items-center button-row exit-row panel-title">
    <h3 class="primary m-b-question m-t-question">
      {{ entry.name | translate  }}
    </h3>
    <button
      mat-flat-button
      class="bticino-ico close round-button-with-background transparent-background"
      style="width: 40px; height: 40px"
      (click)="onCloseTooltip()"
    >
    </button>
  </div>
  <p class="primary p-r-29 m-t-0 p-y panel-description">
      {{entry.tooltip | translate}}
  </p>
  <p class="primary p-r-29 m-t-0 p-y panel-description">
      {{entry.tooltip2 | translate}}
  </p>
  <p class="primary m-b-32 p-r-29 m-t-0 p-y panel-description">
      {{entry.tooltip3 | translate}}
  </p>
  <!-- <div class="black-background black-band d-flex flex-row flex-wrap justify-content-between small-font panel-description">
    <div class="d-flex flex-row flex-nowrap align-items-center ">
      <span class="bticino-ico white telephone"></span>
      <span class="text-white secondary m-l-11 font-weight-bold"> {{'b2c.IDS_IU_POPUP_PHONE' | translate}}</span>
    </div>
    <div class="d-flex flex-row flex-nowrap align-items-center ">
      <span class="bticino-ico white key"></span>
      <span class="text-white secondary m-l-11 font-weight-bold">{{'b2c.IDS_IU_POPUP_GATE' | translate}}</span>
    </div>
    <div class="d-flex flex-row flex-nowrap align-items-center ">
      <span class="bticino-ico white eye"></span>
      <span class="text-white secondary m-l-11 font-weight-bold" style="max-width: 109px" >{{'b2c.IDS_IU_POPUP_EYE' | translate}}</span>
    </div>
    <div class="d-flex flex-row flex-nowrap align-items-center ">
      <span class="bticino-ico white lightbulb"></span>
      <span class="text-white secondary m-l-11 font-weight-bold">{{'b2c.IDS_IU_POPUP_LIGHT' | translate}}</span>
    </div>
  </div> -->
  <!-- <div class="p-x-23 p-t-video p-b-video">
    <video width="100%" controls [autoplay]="false" [muted]="true">
      <source [src]="entry.videoUrl" type="video/mp4">
      {{'b2c.IDS_IU_POPUP_VIDEO_ERROR' | translate}}
    </video>
  </div> -->
  <div class="p-b-video lateral-panel-media" *ngIf="entry.videoUrl">
    <video width="100%" controls [autoplay]="false" [muted]="true" class="lateral-panel-video">
      <source [src]="entry.videoUrl" type="video/mp4">
      {{'b2c.IDS_IU_POPUP_VIDEO_ERROR' | translate}}
    </video>
  </div>
</app-lateral-panel>
